import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import ControlTitle from "../ControlTitle";

class TextField extends Component {
  shouldComponentUpdate(nextProps) {
    const different =
      this.props.element_value !== nextProps.element_value ||
      this.props.error !== nextProps.error ||
      this.props.validate !== nextProps.validate;
    return different;
  }

  handleChange(e) {
    this.props.onChange(
      this.props.repeatingForm,
      this.props.element_id,
      e.target.value
    );
  }

  renderInput() {
    const { element_value, validate, error, ...formControl } = this.props;
    var maxLength = formControl.element_params.H;

    if (validate && error) {
      return (
        <input
          type="text"
          className="error"
          maxLength={maxLength}
          value={element_value}
          onChange={this.handleChange.bind(this)}
        />
      );
    }

    return (
      <input
        type="text"
        value={element_value}
        maxLength={maxLength}
        onChange={this.handleChange.bind(this)}
      />
    );
  }

  render() {
    const { element_prompt, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          <div>{this.renderInput()}</div>
        </Form.Field>
      </div>
    );
  }
}

TextField.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/TextField/index.js